(() => {
  'use strict';
  function validName(value, limit, mode) {
    const name = value.trim().normalize('NFC');
    if (!name) return 'Please enter a name.';
    if ([...name].length > limit) return `Please use ${limit} characters or fewer.`;
    const pattern = mode === 'international' ? /^\p{L}+(?:[ '\u2019-]\p{L}+)*$/u : /^[A-Za-z]+(?:[ '\u2019-][A-Za-z]+)*$/;
    if (!pattern.test(name)) return mode === 'international' ? 'Use letters, spaces, apostrophes, or hyphens between letters.' : 'Use letters A–Z, spaces, apostrophes, or hyphens between letters.';
    return '';
  }
  function status(message) { const node = document.getElementById('CraftStatus'); if (node) node.textContent = message; }
  function selectMedia(section, id) {
    if (!id || !section.querySelector(`[data-product-media="${id}"]`)) return;
    section.querySelectorAll('[data-product-media]').forEach(el => { el.hidden = el.dataset.productMedia !== String(id); });
    section.querySelectorAll('[data-media-target]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.mediaTarget === String(id))));
  }
  function initialize(scope = document) {
    scope.querySelectorAll('[data-menu-toggle]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const nav = document.getElementById(button.getAttribute('aria-controls'));
        const open = nav.classList.toggle('open');
        button.setAttribute('aria-expanded', String(open));
        button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      });
    });
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.bound) return;
      section.dataset.bound = 'true';
      const form = section.querySelector('.craft-product-form');
      const variant = form.querySelector('[data-variant-select]');
      const buy = form.querySelector('[data-add-button]');
      const personal = form.querySelector('[data-personalization]');
      const names = [...form.querySelectorAll('[data-personal-name]')];
      const lettering = form.querySelector('[data-lettering]');
      const confirm = form.querySelector('[data-spelling-confirm]');
      const error = form.querySelector('[data-name-error]');
      const qty = form.querySelector('[name="quantity"]');
      function preview() {
        const first = form.querySelector('[data-name-preview]');
        const second = form.querySelector('[data-second-preview]');
        if (first) first.textContent = names[0]?.value || 'Their name';
        if (second) second.textContent = names[1]?.value || 'Their name';
        const box = form.querySelector('.craft-live-preview');
        if (box) box.style.fontFamily = lettering?.value.toLowerCase().includes('classic') ? 'Georgia, serif' : 'var(--heading)';
      }
      function saveDraft() {
        if (!personal) return;
        try { sessionStorage.setItem(`craftstoy-name-${personal.dataset.productId}`, JSON.stringify({names:names.map(n=>n.value),lettering:lettering?.value,quantity:qty?.value})); } catch { /* Browser storage is optional. */ }
      }
      if (personal?.dataset.ready === 'true') {
        try {
          const draft = JSON.parse(sessionStorage.getItem(`craftstoy-name-${personal.dataset.productId}`) || 'null');
          if (draft) {
            names.forEach((n,i) => { if (typeof draft.names?.[i] === 'string') n.value = draft.names[i].slice(0,Number(personal.dataset.limit)); });
            if (lettering && [...lettering.options].some(o=>o.value===draft.lettering)) lettering.value=draft.lettering;
            if (qty && Number.isInteger(Number(draft.quantity)) && Number(draft.quantity)>0) qty.value=draft.quantity;
          }
        } catch { /* Discard invalid draft. */ }
        names.forEach(input => input.addEventListener('input', () => {
          if (confirm) confirm.checked=false;
          const message = input.value ? validName(input.value, Number(personal.dataset.limit), personal.dataset.characterMode) : '';
          input.setCustomValidity(message);
          input.setAttribute('aria-invalid',String(Boolean(message)));
          if (error) error.textContent=message;
          preview(); saveDraft();
        }));
        lettering?.addEventListener('change',()=>{preview();saveDraft()});
        qty?.addEventListener('change',saveDraft);
        form.addEventListener('submit',event=>{
          for (const input of names) {
            const message=validName(input.value,Number(personal.dataset.limit),personal.dataset.characterMode);
            input.setCustomValidity(message);
            if (message) { event.preventDefault(); if(error)error.textContent=message;input.reportValidity();return; }
            input.value=input.value.trim();
          }
          if (!confirm?.checked) { event.preventDefault();confirm?.reportValidity();return; }
          saveDraft();
        });
      }
      function updateVariant(updateUrl) {
        const option=variant?.selectedOptions[0];
        if (!option) return;
        const price=form.querySelector('[data-product-price]');const compare=form.querySelector('[data-compare-price]');
        const pricingPending=section.dataset.pricePending==='true';
        if(price)price.textContent=pricingPending?'Price to be confirmed':option.dataset.price;
        if(compare){compare.textContent=option.dataset.compare;compare.hidden=pricingPending||option.dataset.onSale!=='true'}
        const ready=buy?.dataset.ready==='true';
        if(buy){buy.disabled=pricingPending||!ready||option.dataset.available!=='true';buy.textContent=pricingPending?'Pricing coming soon':!ready?'Personalization coming soon':option.dataset.available==='true'?'Add to Bag':'Sold out'}
        if(qty){qty.min=option.dataset.min||'1';qty.step=option.dataset.step||'1';if(option.dataset.max)qty.max=option.dataset.max;else qty.removeAttribute('max');const min=Number(qty.min),max=Number(qty.max)||Infinity,step=Number(qty.step);const normalized=min+Math.ceil(Math.max(0,Number(qty.value)-min)/step)*step;qty.value=String(Math.min(max,Math.max(min,normalized)))}
        selectMedia(section,option.dataset.mediaId);
        if(updateUrl){const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);status('Product option and price updated.');}
      }
      const addonRows = [...form.querySelectorAll('[data-addon-item]')];
      addonRows.forEach(row => {
        const check = row.querySelector('[data-addon-check]');
        check.disabled = check.dataset.available !== 'true';
        row.querySelector('[data-addon-variant]')?.addEventListener('change', event => {
          const selected = event.target.selectedOptions[0];
          row.querySelector('[data-addon-price]').textContent = selected?.dataset.price || '';
        });
      });
      form.addEventListener('submit', async event => {
        if (event.defaultPrevented) return;
        if (form.dataset.submitting === 'true') { event.preventDefault(); return; }
        const chosen = addonRows.filter(row => row.querySelector('[data-addon-check]').checked);
        if (!chosen.length) return;
        event.preventDefault();
        const addonError = form.querySelector('[data-addon-error]');
        addonError.textContent = '';
        if (!form.checkValidity()) { form.reportValidity(); return; }
        if (!buy || buy.dataset.ready !== 'true' || section.dataset.pricePending === 'true') return;
        const data = new FormData(form), properties = {};
        for (const [key, value] of data) { const match = key.match(/^properties\[(.+)\]$/); if (match) properties[match[1]] = value; }
        const quantity = Number(qty?.value || 1);
        const items = [{id:variant.value, quantity, properties:{...properties}}];
        for (const row of chosen) {
          const selected = row.querySelector('[data-addon-variant]').selectedOptions[0];
          const min = Number(selected?.dataset.min || 1), step = Number(selected?.dataset.step || 1), max = Number(selected?.dataset.max) || Infinity;
          if (!selected || selected.disabled || !Number.isInteger(quantity) || quantity < min || quantity > max || (quantity-min)%step !== 0) {
            addonError.textContent = 'Please review the selected extra and its quantity requirements, or add it from its product page.';
            return;
          }
          items.push({id:selected.value,quantity,properties:{...properties}});
        }
        const root = window.Shopify?.routes?.root || document.body.dataset.shopRoot || '/';
        const label = buy.textContent;
        form.dataset.submitting = 'true'; buy.disabled = true; buy.textContent = 'Adding your pieces…';
        try {
          const response = await fetch(`${root}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Could not add your selection.');
          location.assign(`${root}cart`);
        } catch (e) {
          addonError.textContent = `${e.message || 'Could not add your selection.'} Review your bag before trying again.`;
          form.dataset.submitting = 'false'; buy.disabled = false; buy.textContent = label;
        }
      });
      variant?.addEventListener('change',()=>updateVariant(true));
      section.querySelectorAll('[data-media-target]').forEach(button=>button.addEventListener('click',()=>selectMedia(section,button.dataset.mediaTarget)));
      preview();updateVariant(false);
    });
  }
  function rememberCartNames(row, properties) {
    if (!row.dataset.productId || (!properties.Name && !properties['First piece name'])) return;
    const names = properties['First piece name'] ? [properties['First piece name'], properties['Second piece name']] : [properties.Name];
    try { sessionStorage.setItem(`craftstoy-name-${row.dataset.productId}`, JSON.stringify({names, lettering:properties.Lettering, quantity:row.dataset.quantity})); } catch { /* Storage is optional. */ }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-cart-product]');
    if (!link) return;
    const row = link.closest('[data-cart-item]');
    try { rememberCartNames(row, JSON.parse(row.dataset.properties)); } catch { /* Keep the native product link. */ }
  });
  document.addEventListener('click', async event => {
    const button=event.target.closest('[data-save-properties]');if(!button)return;
    const row=button.closest('[data-cart-item]');const error=row.querySelector('[data-cart-error]');error.textContent='';
    let properties;try{properties=JSON.parse(row.dataset.properties)||{}}catch{error.textContent='Please refresh your bag and try again.';return}
    const fields=[...row.querySelectorAll('[data-edit-property]')];
    for(const field of fields){const message=validName(field.value,Number(properties['_Name limit'])||24,properties['_Character mode']||'latin');if(message){error.textContent=message;field.focus();return}properties[field.dataset.editProperty]=field.value.trim()}
    if(!row.querySelector('[data-edit-confirm]').checked){error.textContent='Please confirm the spelling and capitalization.';return}
    properties['Spelling confirmed']='Yes';button.disabled=true;button.textContent='Saving…';
    try {
      const root=window.Shopify?.routes?.root||document.body.dataset.shopRoot||'/';
      const response=await fetch(`${root}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:row.dataset.key,quantity:Number(row.dataset.quantity),properties})});
      const result=await response.json();if(!response.ok)throw new Error(result.description||result.message||'Could not save personalization.');
      rememberCartNames(row,properties);
      location.reload();
    } catch(e){error.textContent=e.message||'Could not save personalization. Please try again.';button.disabled=false;button.textContent='Save Personalization';}
  });
  document.addEventListener('input',event=>{if(event.target.matches('[data-edit-property]')){const confirm=event.target.closest('[data-cart-item]').querySelector('[data-edit-confirm]');if(confirm)confirm.checked=false}});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.nav-dropdown[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus()});const b=document.querySelector('[data-menu-toggle][aria-expanded="true"]');if(b){document.getElementById(b.getAttribute('aria-controls')).classList.remove('open');b.setAttribute('aria-expanded','false');b.setAttribute('aria-label','Open menu');b.focus()}}});
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('shopify:block:select',event=>{const details=event.target.closest('details');if(details)details.open=true});
  initialize();
})();
